export * from './html/core';



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-drawing/dist/es/html.js
// module id = ../../../../@progress/kendo-drawing/dist/es/html.js
// module chunks = vendor